import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var RadioGroupWrapper = function RadioGroupWrapper(props) {
  return /*#__PURE__*/_jsx("div", {
    className: cn(_defineProperty({}, styles['with-top-margin'], props.withTopMargin)),
    children: props.children
  });
};
RadioGroupWrapper.displayName = 'RadioGroupWrapper';